import React from 'react';

export const CoverageHero = ({ title, subtitle, eyebrow = 'Coverage With Purpose' }) => (
  <section
    className="relative bg-cover bg-center py-12"
    style={{ backgroundImage: 'linear-gradient(rgba(0, 71, 171, 0.92), rgba(0, 55, 140, 0.88)), url(https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1200)' }}
    data-testid="coverage-hero"
  >
    <div className="container mx-auto px-4 text-center text-white">
      {eyebrow && (
        <span className="inline-block text-brand-orange font-semibold tracking-widest uppercase text-sm mb-4" data-testid="coverage-hero-eyebrow">
          {eyebrow}
        </span>
      )}
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">{title}</h1>
      <p className="text-lg md:text-xl max-w-3xl mx-auto">{subtitle}</p>
    </div>
  </section>
);

export default CoverageHero;
